import {
  Directive,
  ElementRef,
  HostListener,
  Input, Optional
} from "@angular/core";
import { FormControlDirective, FormControlName, NgControl, NgModel } from "@angular/forms";
import { CustomDirectiveConfig } from "@app/shared/models";
import { EMAIL_LIKE_FORM_CONTROL_NAMES, EXCEPTION_FIELD_CLASS_NAMES_TO_CAPITALIZE_INITIAL_CHARACTER } from "../../utils/variables.utils";
import { removeSelectedTextFromString } from "@app/shared";
@Directive({
  selector: "[validateInput],[formControlName][validateInput],[formControl][validateInput]",
})
export class ValidateInputDirective {
  @Input("validateInput") config? = new CustomDirectiveConfig();
  private regex: RegExp;
  private specialKeys: Array<string> = ["Backspace"];

  constructor(
    private elementRef: ElementRef<any>,
    @Optional() private controlDir: NgControl
  ) { }

  ngOnInit() {
    if (this.config == null || this.config == undefined) {
      return;
    }
    switch (true) {
      case this.config.isANumberWithZero:
        this.regex = new RegExp(/^([0-9][0-9]*)$/g);
        break;
      case this.config.isANumberWithHash:
        this.regex = new RegExp(/^[0-9#]+$/g);
        break;
      case this.config.isANumberWithColon:
        this.regex = new RegExp(/^[0-9:0-9]+$/g);
        break;
      case this.config.isANumberOnly:
        this.regex = new RegExp(/^([0-9][0-9]*)$/g);
        break;
      case this.config.isAStringOnly:
        this.regex = new RegExp(/^[a-zA-Z0-9*--%!.@\s#$&:\\-`.+,/\"]*$/g);
        break;
      case this.config.isAStringOnlyNoSpace:
        this.regex = new RegExp(/^([a-zA-Z]*)$/g);
        break;
      case this.config.isAStringWithHyphenDash:
        this.regex = new RegExp(/^[a-zA-Z-_]*$/g);
        break;
      case this.config.isAStringWithHyphenDashAnd:
        this.regex = new RegExp(/^[a-zA-Z-_& ]*$/g);
        break;
      case this.config.isHypenOnly:
        this.regex = new RegExp(/^((?!-)(?!.*--)[a-zA-Z0-9 -]*)$/g);
        break;
      case this.config.isMltiDotsRestrict:
        this.regex = new RegExp(/^((?!\.)(?!.*\.\.)[a-zA-Z0-9 .]*)$/g);
        break;
      case this.config.isAnAlphaNumericOnly:
        this.regex = new RegExp(/^([a-zA-Z0-9 -]*)$/g);
        break;
      case this.config.isAnAlphaNumericWithSlash:
        this.regex = new RegExp(/^([a-zA-Z0-9/]*)$/g);
        break;
      case this.config.isAnAlphaNumericWithDash:
        this.regex = new RegExp(/^([a-zA-Z0-9-]*)$/g);
        break;
      case this.config.isADecimalOnly:
        this.regex = new RegExp(/^\d+(\.\d{0,2})?$/);
        break;
      case this.config.isADecimalOnlyWithHypen:
        this.regex = new RegExp(/^-?\d+(\.\d{0,2})?$/);
        break;
      case this.config.isADecimalOnlyWithStartHypen:
        this.regex = new RegExp(/^-?\d*\.?\d{0,2}$/);
        break;
      case this.config.isADecimalFourOnly:
        this.regex = new RegExp(/^\d+(\.\d{0,4})?$/);
        break;
      case this.config.isAlphaSpecialCharterOnly:
        this.regex = new RegExp(/^[a-zA-Z @+*'.&$'\"=/\,\-\s]{1,255}$/g);
        break;
      case this.config.isAlphaNumericSpecialCharterWithBrackets:
        this.regex = new RegExp(/^[a-zA-Z0-9 @+*'.&()$'\"=/\,\-\s]{1,255}$/g);
        break;
      case this.config.isAlphaSomeSpecialCharterOnly:
        this.regex = new RegExp(/^[a-zA-Z &/s]{1,255}$/g);
        break;
      case this.config.isAlphaNumericSomeSpecialCharterOnly:
        this.regex = new RegExp(/^[a-zA-Z0-9 &/s]{1,255}$/g);
        break;
      case this.config.isAlphaSpecialCharterOnlyRestrictCommetntSymbol:
        this.regex = new RegExp(/^(?!.*--)[a-zA-Z \-]+$/g);
        break;
      case this.config.isANumberWithoutZeroStartWithMaxTwoNumbers:
        this.regex = new RegExp(/^((?!(0))[0-9]{1,2})$/g);
        break;
      case this.config.isANumberWithoutZeroStartWithMaxThreeNumbers:
        this.regex = new RegExp(/^((?!(0))[0-9]{1,3})$/g);
        break;
      case this.config.isANumberWithZeroStartWithMaxThreeNumbers:
        this.regex = new RegExp(/^([0-9]{1,3})$/g);
        break;
      case this.config.isANumberWithoutZeroStartWithMaxTwoNumbersDecimal:
        this.regex = new RegExp(/^((?!(0))[0-9]{1,2}(\.\d{1,2})*)$/g);
        break;
      case this.config.isANumberWithHypen:
        this.regex = new RegExp(/^[0-9-]+$/g);
        break;
      case Object.keys(
        this.config.isADecimalWithConfig ? this.config.isADecimalWithConfig : {}
      ).length > 0:
        const trailingDotDigitsCount = this.config.isADecimalWithConfig
          .trailingDotDigitsCount;
        switch (trailingDotDigitsCount) {
          case 1:
            this.regex = new RegExp(/^\d{1,1}(\.\d{0,2})?$/);
            break;
          case 2:
            this.regex = new RegExp(/^\d{1,2}(\.\d{0,2})?$/);
            break;
          case 3:
            this.regex = new RegExp(/^\d{1,3}(\.\d{0,2})?$/);
            break;
          case 4:
            this.regex = new RegExp(/^\d{1,4}(\.\d{0,2})?$/);
            break;
          case 5:
            this.regex = new RegExp(/^\d{1,5}(\.\d{0,2})?$/);
            break;
          case 6:
            this.regex = new RegExp(/^\d{1,6}(\.\d{0,2})?$/);
            break;
          case 7:
            this.regex = new RegExp(/^\d{1,7}(\.\d{0,2})?$/);
            break;
          case 8:
            this.regex = new RegExp(/^\d{1,8}(\.\d{0,2})?$/);
            break;
          case 9:
            this.regex = new RegExp(/^\d{1,9}(\.\d{0,2})?$/);
            break;
          case 10:
            this.regex = new RegExp(/^\d{1,9}(\.\d{0,15})?$/);
            break;
        }
        break;
      case this.config.isAddressOnly:
        this.regex = new RegExp(/^([a-zA-Z0-9, /]*)$/g);
        break;
      case this.config.isAccountNumber:
        this.regex = new RegExp(/^([0-9]{0,12})$/g);
        break;
      case this.config.isAValidPhoneNumberOnly:
        this.regex = new RegExp(/^([0-9 ]{0,12})$/g);
        break;
      case this.config.isAlphaNumericWithPasteOnly:
        this.regex = new RegExp(/^([a-zA-Z0-9 ]*)$/g);
        break;
      case this.config.isAStringOnlySpaceDot:
        this.regex = new RegExp(/^([a-zA-Z .]*)$/g);
        break;
      case this.config.isAStringOnlySpaceAnd:
        this.regex = new RegExp(/^([a-zA-Z &]*)$/g);
        break;
      case this.config.isAStringSomeSpecialCharterOnly:
        this.regex = new RegExp(/^([a-zA-Z0-9 $]*)$/g);
        break;
      case this.config.isPercentageOnly:
        this.regex = new RegExp(/^(?!0)(?!00)[0-9]{1,2}(\.(?!00)\d{0,2})?$/g);
        break;
      case this.config.isPercentageWithZeroOnly:
        this.regex = new RegExp(/^[0-9]{1,2}(\.(?!00)\d{0,2})?$/g);
        break;
      case this.config.isLatOrLong:
        this.regex = new RegExp(/^-?\d*\.?\d{0,6}$/g);
        break;
      case this.config.isAStringOnlyBetweenSpace:
        this.regex = new RegExp(/^[A-Za-z]+[A-Za-z ]*$/g)
        break;
      case this.config.isAStringNumericOnlyBetweenSpace:
        this.regex = new RegExp(/^[A-Za-z]+[A-Za-z0-9 ]*$/g)
        break;
      case this.config.isADecimalMaxTwoDigitsTwoDecimals:
        this.regex = new RegExp(/^\d{1,2}(\.\d{0,2})?$/g);
        break;
      case this.config.isANumberZeroToNinetyNine:
        this.regex = new RegExp(/^([0-9]{1,2})$/g);
        break;
      default:
        this.regex = new RegExp(/^.{1,}$/g);
        break;
    }
  }

  get nativeElement() {
    return this.elementRef.nativeElement.children.length === 0 ? this.elementRef.nativeElement : this.elementRef.nativeElement.children[0];
  }

  get nativeElementLocalName() {
    return this.elementRef.nativeElement.localName;
  }


  nativeElementLocalNameFn(): boolean {
    return ((this.nativeElementLocalName === 'input' && this.nativeElement.type === 'text') || this.nativeElementLocalName === 'input-custom-control'
      || this.nativeElementLocalName === 'textarea' || this.nativeElementLocalName === 'text-area-custom-control' ||
      this.nativeElementLocalName === 'mat-select-autocomplete-custom-control');
  }

  @HostListener("keypress", ["$event"])
  onKeyPress(event: KeyboardEvent) {
    /* filter the native elements only whichever is applicable to look for key press event 
     and if the control is defined as formControlName in the form */
    if (this.controlDir instanceof FormControlName || this.controlDir instanceof FormControlDirective) {
      const current: string = this.nativeElement.value;
      let next: string;
      const selectionStart = this.elementRef.nativeElement.selectionStart;
      const selectionEnd = this.elementRef.nativeElement.selectionEnd;
      
      if (selectionStart === current.length && selectionEnd === current.length) {
        next = current.concat(event.key);
      }
      else {
        // if the value is added or deleted in between then persist the cursor position's value and append them into the value accordingly
        // When text is selected, remove the selected text and insert at selectionStart
        next = this.nativeElement.value.substring(0, selectionStart) +
          event.key + this.nativeElement.value.substring(selectionEnd)
      }
      // the below email validation is exception from this keypress event since we created a seperate email.validator.ts file for handling
      if (!EMAIL_LIKE_FORM_CONTROL_NAMES.includes(this.nativeElement?.id?.toLowerCase())) {
        // skip capitalizing first letter of a word those values are having GUID dropdown values 
        if (this.nativeElementLocalNameFn()) {
          setTimeout(() => {
            this.capitalizeFirstLetterOfWord(this.currentElement['value']);
          });
        }
        // remove space starts as a initial character
        setTimeout(() => {
          const trailingWhitespace = this.nativeElement?.value?.length == 0 ? event.key.startsWith(' ')
            : this.nativeElement?.value.startsWith(' ') ? true : false;
          if (trailingWhitespace) {
            event.preventDefault();
            this.controlDir.control.setValue(this.controlDir.control?.value?.trim());
            this.elementRef.nativeElement.selectionStart = 0;
            this.elementRef.nativeElement.selectionEnd = 0;
          }
        });
        // Allow Backspace and hyphen keys
        if (this.specialKeys.indexOf(event.key) !== -1 && event.code !== 'Tab') {
          return;
        }
        const isRegExpSatisfied = next && String(next).match(this.regex);
        if (isRegExpSatisfied) {
          // Validate min/max for isADecimalMaxTwoDigitsTwoDecimals (0 to 99.99)
          if (this.config?.isADecimalMaxTwoDigitsTwoDecimals) {
            const numValue = parseFloat(next);
            if (isNaN(numValue) || numValue < 0 || numValue > 99.99) {
              event.preventDefault();
              return;
            }
          }
          // Validate min/max for isANumberZeroToNinetyNine (0 to 99)
          if (this.config?.isANumberZeroToNinetyNine) {
            const numValue = parseInt(next, 10);
            if (isNaN(numValue) || numValue < 0 || numValue > 99) {
              event.preventDefault();
              return;
            }
          }
          if (next && !String(next).match(this.regex) && event.code.includes('Digit')) {
            // add your logics additionally for decimal pointed form controls
          }
          else if (next && !String(next).match(this.regex) && event.code !== 'Tab' && !event.code.includes('Digit')) {
            event.preventDefault();
          }
        } else if (this.config?.isADecimalOnlyWithHypen && next == '-' && (this.controlDir?.name == 'debitAmount' || this.controlDir?.name == 'creditAmount' || this.controlDir?.name == 'outstandingAmount')) {

        }
        else {
          event.preventDefault();
        }
      }
    }
    // if the control is defined as formControlDirective in the form
    else if (this.controlDir instanceof FormControlDirective && !this.nativeElementLocalNameFn()) {
      console.error(`Cannot handle ${this.controlDir.control} field since it is not a proper formControlName`);
    } else if (this.controlDir instanceof NgModel && this.nativeElementLocalNameFn()) {
      let current: string = this.nativeElement.value;
      const selectionStart = this.nativeElement.selectionStart;
      const selectionEnd = this.nativeElement.selectionEnd;
      // When text is selected, remove the selected text and insert at selectionStart
      const next: string = [current.slice(0, selectionStart), event.key == 'Decimal' ? '.' : event.key, current.slice(selectionEnd)].join('');
      if (next && !String(next).match(this.regex)) {
        event.preventDefault();
      }
    }
  }

  // since keypress events doesn't recognize the delete and backspace key events we used keydown event
  @HostListener("keydown", ["$event"])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Delete' || event.key === 'Backspace') {
      /* filter the native elements only whichever is applicable to look for key press event 
       and if the control is defined as formControlName in the form */
      if (this.controlDir instanceof FormControlName || this.controlDir instanceof FormControlDirective) {
        // the below email validation is exception from this keypress event since we created a seperate email.validator.ts file for handling
        if (!EMAIL_LIKE_FORM_CONTROL_NAMES.includes(this.nativeElement?.id?.toLowerCase())) {
          let actualValueAfterDeleteOrBackSpace = "";
          // skip capitalizing first letter of a word those values are having GUID dropdown values 
          if (this.nativeElementLocalNameFn()) {
            if (this.elementRef.nativeElement.selectionStart == this.elementRef.nativeElement.selectionEnd) {
              // making sure even on the empty space deletions 
              actualValueAfterDeleteOrBackSpace = event.target['value'].substring(0, this.elementRef.nativeElement.selectionStart - 1) + event.target['value'].substring(this.elementRef.nativeElement.selectionStart, event.target['value'].length);
            }
            this.capitalizeFirstLetterOfWord(actualValueAfterDeleteOrBackSpace, this.elementRef.nativeElement.selectionStart == 1 ? true : false);
          }
          setTimeout(() => {
            // remove space starts as a initial character
            if (actualValueAfterDeleteOrBackSpace.startsWith(' ')) {
              event.preventDefault();
              this.controlDir.control.setValue(this.controlDir.control.value?.trim());
              this.elementRef.nativeElement.selectionStart = 0;
              this.elementRef.nativeElement.selectionEnd = 0;
            }
          });
        }
      }
      // if the control is defined as formControlDirective in the form
      else if (this.controlDir instanceof FormControlDirective && !this.nativeElementLocalNameFn()) {
        console.error(`Cannot handle ${this.controlDir.control} field since it is not a proper formControlName`);
      }
    }
  }

  @HostListener('paste', ['$event'])
  onKeyPaste(event: KeyboardEvent | any) {
    // this condition is to prevent the user from pasting data into disabled fields
    if (this.nativeElement.disabled) return;
    if (this.config?.shouldPasteKeyboardEventBeRestricted) {
      event.preventDefault();
    }
    /* filter the native elements only whichever is applicable to look for key press event 
     and if the control is defined as formControlName in the form */
    else if (this.controlDir instanceof FormControlName || this.controlDir instanceof FormControlDirective) {
      /* for fields doesn't have validateInput attribute will be returned here. 
         Hence they will never be validated with the below written logics */
      if (this.config == null || this.config == undefined) {
        return;
      }
      let finalClipboardData = '';
      const fieldValue = this.nativeElement.value;
      let pastedText = event["clipboardData"].getData("text");
      if (pastedText) {
        finalClipboardData = this.onFindRegex(fieldValue, pastedText, finalClipboardData);
        setTimeout(() => { // skip capitalizing first letter of a word those values are having GUID dropdown values 
          if (this.nativeElementLocalNameFn() && finalClipboardData) {
            this.capitalizeFirstLetterOfWord(finalClipboardData?.trim());
          }
          // Validate min/max for isADecimalMaxTwoDigitsTwoDecimals (0 to 99.99)
          if (this.config.isADecimalMaxTwoDigitsTwoDecimals && finalClipboardData) {
            const numValue = parseFloat(finalClipboardData.trim());
            if (!isNaN(numValue)) {
              if (numValue < 0) {
                finalClipboardData = '0';
              } else if (numValue > 99.99) {
                finalClipboardData = '99.99';
              }
            }
          }
          // Validate min/max for isANumberZeroToNinetyNine (0 to 99)
          if (this.config.isANumberZeroToNinetyNine && finalClipboardData) {
            const numValue = parseInt(finalClipboardData.trim(), 10);
            if (!isNaN(numValue)) {
              if (numValue < 0) {
                finalClipboardData = '0';
              } else if (numValue > 99) {
                finalClipboardData = '99';
              }
            }
          }
          // if (finalClipboardData) {
          this.controlDir.control.setValue(finalClipboardData?.trim());
          // }
        });
      }
    }
    // if the control is defined as formControl in the form
    else if (this.controlDir instanceof FormControlDirective && !this.nativeElementLocalNameFn()) {
      console.error(`Cannot handle ${this.controlDir.control} field since it is not a proper formControlName`);
    } else if (this.controlDir instanceof NgModel && this.nativeElementLocalNameFn()) {
      let finalClipboardData = '';
      let clipboardData = event?.clipboardData || window['clipboardData'];
      const fieldValue = this.nativeElement.value;
      let pastedText = clipboardData?.getData('text');
      finalClipboardData = this.onFindRegex(fieldValue, pastedText, finalClipboardData);
      console.log("finalClipboardData: ", finalClipboardData);
      setTimeout(() => { // skip capitalizing first letter of a word those values are having GUID dropdown values 
        if (this.nativeElementLocalNameFn()) {
          this.capitalizeFirstLetterOfWord(finalClipboardData?.trim());
        }
        // Validate min/max for isADecimalMaxTwoDigitsTwoDecimals (0 to 99.99)
        if (this.config.isADecimalMaxTwoDigitsTwoDecimals && finalClipboardData) {
          const numValue = parseFloat(finalClipboardData.trim());
          if (!isNaN(numValue)) {
            if (numValue < 0) {
              finalClipboardData = '0';
            } else if (numValue > 99.99) {
              finalClipboardData = '99.99';
            }
          }
        }
        // Validate min/max for isANumberZeroToNinetyNine (0 to 99)
        if (this.config.isANumberZeroToNinetyNine && finalClipboardData) {
          const numValue = parseInt(finalClipboardData.trim(), 10);
          if (!isNaN(numValue)) {
            if (numValue < 0) {
              finalClipboardData = '0';
            } else if (numValue > 99) {
              finalClipboardData = '99';
            }
          }
        }
        this.nativeElement.value = finalClipboardData?.trim();
      });
    }
  }

  onFindRegex(fieldValue, pastedText, finalClipboardData) {
    // Paste issue resolved here don't delete this
    if (this.elementRef.nativeElement.selectionStart === 0 &&
      this.elementRef.nativeElement.selectionEnd === fieldValue.length) {
      fieldValue = '';
      pastedText = pastedText;
    } else if (this.elementRef.nativeElement.selectionStart !== this.elementRef.nativeElement.selectionEnd) {
      if (this.elementRef.nativeElement.selectionStart >= 0 && this.elementRef.nativeElement.selectionEnd > 0) {
        fieldValue = removeSelectedTextFromString(fieldValue, this.elementRef.nativeElement.selectionStart, this.elementRef.nativeElement.selectionEnd);
      }
    }
    switch (true) {
      case this.config.isAStringOnly:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/[a-zA-Z0-9*--%!.@\s#$&\\-`.+,/\"]*$/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isAStringWithHyphenDashAnd:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/^[a-zA-Z-_& ]*$/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isANumberOnly:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/[0-9]/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isAnAlphaNumericOnly:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/[a-zA-Z0-9 -]/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isAnAlphaNumericWithSlash:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/[a-zA-Z0-9/]/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isAnAlphaNumericWithDash:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/[a-zA-Z0-9-]/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isANumberWithoutZeroStartWithMaxTwoNumbers:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/^((?!(0))[0-9]{1,2})$/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isANumberWithoutZeroStartWithMaxThreeNumbers:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/^((?!(0))[0-9]{1,3})$/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isANumberWithZeroStartWithMaxThreeNumbers:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/^([0-9]{1,3})$/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isADecimalOnly:
        // this.regex = new RegExp(/^\d+(\.\d{0,2})?$/);
        pastedText = fieldValue + pastedText;
        pastedText?.match(/^\d+(\.\d{0,2})?$/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isADecimalOnlyWithHypen:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/^-?\d+(\.\d{0,2})?$/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isADecimalOnlyWithStartHypen:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/^-?\d*\.?\d{0,2}$/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      // number with space mask
      case new RegExp(/^([0-9 ]*)$/g).test(pastedText):
        pastedText = fieldValue + pastedText;
        pastedText?.match(/[0-9]/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isAValidPhoneNumberOnly:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/[0-9]/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        if (finalClipboardData.length > 10) {
          finalClipboardData = finalClipboardData.slice(0, 10);
        }
        this.applySpaceMaskToMobileNumbers(finalClipboardData, false);
        break;
      case Object.keys(this.config?.isADecimalWithConfig ? this.config.isADecimalWithConfig : {}).length > 0:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/[0-9]/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      // Pasted text will not append with field value. Its same as isAnAlphaNumericOnly
      case this.config.isAlphaNumericWithPasteOnly:
        pastedText = pastedText;
        pastedText?.match(/[a-zA-Z0-9 ]/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isAnSAIDNumberOnly:
        if (fieldValue?.length <= 6) {
          pastedText = fieldValue + pastedText;
          pastedText?.match(/^([0-9]{2}(([0][1-9])|([1][0-2])){1}(([0-2][1-9])|([3][0-1])){1})$/g)?.forEach((word: string) => {
            finalClipboardData += word;
          });
        }
        break;
      case this.config.isAStringOnlySpaceDot:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/[a-zA-Z .]/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isAStringOnlySpaceAnd:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/[a-zA-Z &]/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isAStringSomeSpecialCharterOnly:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/[a-zA-Z0-9 $]/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isAlphaNumericSpecialCharterWithBrackets:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/^[a-zA-Z0-9 @+*'.&()$'\"=/\,\-\s]{1,255}$/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isLatOrLong:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/^-?\d*\.?\d{0,6}$/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isAStringOnlyBetweenSpace:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/^[A-Za-z]+[A-Za-z ]*$/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isAStringNumericOnlyBetweenSpace:
        pastedText = fieldValue + pastedText;
        pastedText?.match(/^[A-Za-z]+[A-Za-z0-9 ]*$/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        break;
      case this.config.isADecimalMaxTwoDigitsTwoDecimals:
        pastedText = fieldValue + pastedText;
        // Extract valid decimal numbers (max 2 digits before decimal, max 2 after)
        const decimalMatches = pastedText?.match(/\d{1,2}(\.\d{0,2})?/g);
        if (decimalMatches && decimalMatches.length > 0) {
          // Take the first valid match and validate range
          const validMatch = decimalMatches[0];
          const numValue = parseFloat(validMatch);
          if (!isNaN(numValue) && numValue >= 0 && numValue <= 99.99) {
            finalClipboardData = validMatch;
          } else if (numValue > 99.99) {
            finalClipboardData = '99.99';
          } else if (numValue < 0) {
            finalClipboardData = '0';
          }
        }
        break;
      case this.config.isANumberZeroToNinetyNine:
        pastedText = fieldValue + pastedText;
        // Extract valid numbers (max 2 digits)
        const numberMatches = pastedText?.match(/\d{1,2}/g);
        if (numberMatches && numberMatches.length > 0) {
          // Take the first valid match and validate range
          const validMatch = numberMatches[0];
          const numValue = parseInt(validMatch, 10);
          if (!isNaN(numValue) && numValue >= 0 && numValue <= 99) {
            finalClipboardData = validMatch;
          } else if (numValue > 99) {
            finalClipboardData = '99';
          } else if (numValue < 0) {
            finalClipboardData = '0';
          }
        }
        break;
      default:
        pastedText = pastedText;
        pastedText?.match(/.{1,}$/g)?.forEach((word: string) => {
          finalClipboardData += word;
        });
        finalClipboardData = fieldValue + finalClipboardData;
        break;
    }
    return finalClipboardData;
  }

  filterSpecificCharactersByRegExp(str: string, regExp: RegExp) {
    return (str.match(regExp) || []).join('');
  }

  applySpaceMaskToMobileNumbers(value, backspace) {
    let newVal = value.replace(/\D/g, '');
    if (backspace && newVal.length <= 6) {
      newVal = newVal.substring(0, newVal.length - 1);
    }
    if (newVal.length === 0) {
      newVal = '';
    } else if (newVal.length <= 2) {
      newVal = newVal.replace(/^(\d{0,2})/, '$1');
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,2})/, '$1 $2');
    } else if (newVal.length <= 10) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,3})(\d{0,4})/, '$1 $2 $3');
    } else {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,3})(\d{0,4})/, '$1 $2 $3');
    }
    this.controlDir.control.setValue(newVal);
  }

  capitalizeFirstLetterOfWord(value: string, preventCursorPosition = false) {
    // Leave the first letter to lower only in case the field is 'password'
    if (EXCEPTION_FIELD_CLASS_NAMES_TO_CAPITALIZE_INITIAL_CHARACTER.filter(field => this.currentElement.classList.contains(field))?.length == 0) {
      // To capitalize the first letter of the word
      if (typeof value === 'string') {
        const firstLetterOfAWord = value.charAt(0);
        if (firstLetterOfAWord !== firstLetterOfAWord.toUpperCase()) {
          value = firstLetterOfAWord.toUpperCase() + value.slice(1);
          this.controlDir.control.setValue(value.trim());
        }
        else if (preventCursorPosition) {
          value = value.trim();
          value = value.charAt(0).toUpperCase() + value.slice(1);
          this.controlDir.control.setValue(value);
          this.elementRef.nativeElement.selectionStart = 0;
          this.elementRef.nativeElement.selectionEnd = 0;
        }
      }
    }
  }

  get currentElement() {
    if (this.nativeElementLocalName === 'select' || this.nativeElementLocalName === 'mat-radio-group') {
      if (this.elementRef.nativeElement.className.includes('mat-form-field-autofill-control cdk-text-field-autofill-monitored')) {
        return this.elementRef.nativeElement;
      }
      else {
        return this.elementRef.nativeElement;
      }
    }
    else if (this.nativeElementLocalName === 'mat-select-autocomplete-custom-control') {
      return this.elementRef.nativeElement.children[0].children[0].children[0].children[0].children[0];
    }
    else if (this.nativeElementLocalName == 'p-calendar') {
      return this.elementRef.nativeElement.children[0]?.children[0];
    }
    else if (this.nativeElementLocalName == 'p-multiselect') {
      return this.elementRef.nativeElement.children[0].children[0].children[0];
    }
    else {
      return this.elementRef.nativeElement.children.length === 0 ? this.elementRef.nativeElement : this.elementRef.nativeElement.children[0];
    }
  }
}
